import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../../../shared/shared.module';
import { NewAgencyRoutingModule } from './new-agency-routing.module';
import { NewAgencyComponent } from './new-agency.component';
import { NewAgencyResolve } from './new-agency.resolve';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        NgxMaskModule.forRoot(),
        SharedModule,
        NewAgencyRoutingModule
    ],
    declarations: [NewAgencyComponent],
    exports: [NewAgencyComponent],
    providers: [NewAgencyResolve]
})
export class NewAgencyModule {}
